exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-90[data-v-150ecc51] {\n\twidth: 90%;\n}\n.w-10[data-v-150ecc51] {\n\twidows: 10%;\n}\n", ""]);

// exports
